module.exports = __webpack_public_path__ + "static/media/N35.abbfce6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N35.svg
// module id = 198
// module chunks = 0